






































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { ReactionEntity } from '@/entities/reaction.entity';
import BulletinReactionService from '@/services/bulletin-reaction.service';
import { BulletinReactionCountEntity } from '@/entities/bulletin-reaction-count.entity';
import BulletinCommentReactionService from '@/services/bulletin-comment-reaction.service';
import { BulletinCommentReactionCountEntity } from '@/entities/bulletin-comment-reaction-count.entity';

@Component<BulletinReactionItem>({
  watch: {
    async show(value) {
      if (value) {
        if (
          'bulletinId' in this.reaction &&
          this.service instanceof BulletinReactionService
        ) {
          this.reactionDetails = await this.service.getMany(
            this.reaction.bulletinId,
            this.reaction.emoticonId,
          );
        } else if (
          'commentId' in this.reaction &&
          this.service instanceof BulletinCommentReactionService
        ) {
          this.reactionDetails = await this.service.getMany(
            this.reaction.commentId,
            this.reaction.emoticonId,
          );
        }
      }
    },
  },
})
export default class BulletinReactionItem extends Vue {
  show = false;

  @Prop()
  service: BulletinReactionService | BulletinCommentReactionService;

  @Prop({ type: Object })
  reaction: BulletinReactionCountEntity | BulletinCommentReactionCountEntity;

  reactionDetails: ReactionEntity[] = [];
}
